import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '妖精漫画网',
  url: 'http://lvtianyuan.com/',
  description: '妖精漫画网是最全的韩国漫画在线阅读平台，提供下拉式韩漫大全、免费漫画在线观看服务。',
  logo: 'http://lvtianyuan.com/logo.png',
  sameAs: ['http://lvtianyuan.com/'],
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '妖精漫画网',
  url: 'http://lvtianyuan.com/',
  description: '妖精漫画网 - 韩国漫画_下拉式韩漫大全_最全的韩漫网_免费漫画在线观看',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://lvtianyuan.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function AppLayout() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <div className="min-h-screen bg-background-50 flex flex-col">
        <ScrollToTop />
        <Navbar />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
      </div>
    </>
  );
}